import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Paginator, PaginatorPageChangeEvent } from 'primereact/paginator';
import React from 'react';
import styled from 'styled-components';

type PageSizeOption = { label: string; value: number };

export const CARD_VIEW_PAGE_SIZE_OPTIONS: PageSizeOption[] = [
  { label: '12 items', value: 12 },
  { label: '24 items', value: 24 },
  { label: '36 items', value: 36 },
];

export const LIST_VIEW_PAGE_SIZE_OPTIONS: PageSizeOption[] = [
  { label: '10 items', value: 10 },
  { label: '20 items', value: 20 },
  { label: '50 items', value: 50 },
];

type Props = {
  totalCount: number;
  pageSize: number;
  first: number;
  onPageChange: (event: PaginatorPageChangeEvent) => void;
  onRowsChange: (e: DropdownChangeEvent) => void;
  pageSizeOptions?: PageSizeOption[];
  isListView: boolean;
};

const DashboardCardsPaginator: React.FC<Props> = ({
  totalCount,
  pageSize,
  first,
  onPageChange,
  onRowsChange,
  pageSizeOptions = CARD_VIEW_PAGE_SIZE_OPTIONS,
  isListView = false,
}) => {
  const template = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink PageLinks NextPageLink',
    RowsPerPageDropdown: () => (
      <>
        <span className="paginator-show-items-label">Show:</span>
        <Dropdown value={pageSize} options={pageSizeOptions} onChange={onRowsChange} className="paginator-dropdown" />
        <span className="paginator-total-count">Total count: {totalCount}</span>
      </>
    ),
    CurrentPageReport: <span style={{ marginLeft: 'auto' }} />,
  };

  return (
    <StyledPaginator
      template={template}
      first={first}
      rows={pageSize}
      totalRecords={totalCount}
      onPageChange={onPageChange}
      className="justify-content-start"
      $isListView={isListView}
    />
  );
};

const StyledPaginator = styled(Paginator)<{ $isListView: boolean }>`
  padding: 0;
  margin-top: 20px;
  background-color: ${({ $isListView }) => ($isListView ? 'transparent' : 'initial')};

  .paginator-show-items-label,
  .paginator-total-count {
    ${(props) => props.theme.typography.bodyInput}
    color: ${(props) => props.theme.colors.primaryBlack};
    font-size: 12px;
  }

  .paginator-total-count {
    margin-left: 12px;
  }

  .paginator-dropdown {
    background-color: transparent;
    padding: 0;
    align-items: center;
    border: none;
    outline: none;
    border-radius: 2px;
    box-shadow: none;
    font-weight: 600;
    font-family: 'Inter';
    & .p-inputtext {
      padding: 0;
      color: ${(props) => props.theme.colors.primaryBlack};
      justify-content: center;
      font-size: 12px;
    }
    & .p-dropdown-trigger {
      padding-top: 1px;
      color: ${(props) => props.theme.colors.primaryBlack};
      width: 10px;
      justify-content: center;
      margin-left: 8px;
    }
  }

  .paginator-dropdown.p-dropdown:not(.p-disabled).p-focus {
    outline: none !important;
    box-shadow: none;
    border: none;
  }
`;

export default DashboardCardsPaginator;
